import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, TrendingUp, BarChart3, Settings, ShoppingCart, Users } from 'lucide-react';

const Dashboard = ({ user, permissions, onLogout }) => {
  const navigate = useNavigate();

  const dashboardItems = [
    {
      title: 'INVENTORY',
      description: 'Manage stock, add new items, track quantities',
      icon: <Package />,
      path: '/inventory',
      className: 'inventory-card',
      permission: 'inventory'
    },
    {
      title: 'ORDERS',
      description: 'Manage production orders, track status',
      icon: <ShoppingCart />,
      path: '/orders',
      className: 'orders-card',
      permission: 'sales'
    },
    {
      title: 'SALES',
      description: 'Process sales, manage transactions',
      icon: <TrendingUp />,
      path: '/sales',
      className: 'sales-card',
      permission: 'sales'
    },
    {
      title: 'CUSTOMERS',
      description: 'Manage customers, view order history',
      icon: <Users />,
      path: '/customers',
      className: 'customers-card',
      permission: 'sales'
    },
    {
      title: 'REPORTS & ANALYTICS',
      description: 'View insights, generate reports, track performance',
      icon: <BarChart3 />,
      path: '/reports',
      className: 'reports-card',
      permission: 'reports'
    },
    {
      title: 'SETTINGS',
      description: 'Configure system, manage users, preferences',
      icon: <Settings />,
      path: '/settings',
      className: 'settings-card',
      permission: 'settings'
    }
  ];

  const availableItems = dashboardItems.filter(item => 
    user?.role === 'admin' || permissions?.[item.permission]
  );

  return (
    <div className="dashboard">
      <nav className="navbar">
        <div className="navbar-brand">addict</div>
        <div className="navbar-right">
          <div className="navbar-user">Welcome, {user?.displayName || user?.username || user?.email}</div>
          <button 
            onClick={onLogout}
            style={{
              background: 'linear-gradient(45deg, #667eea, #764ba2)',
              color: 'white',
              border: 'none',
              padding: '8px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '13px',
              whiteSpace: 'nowrap'
            }}
          >
            Logout
          </button>
        </div>
      </nav>
      
      <div className="dashboard-content">
        <h1 className="dashboard-title">Dashboard</h1>
        
        <div className="dashboard-grid">
          {availableItems.map((item, index) => (
            <div
              key={index}
              className={`dashboard-card ${item.className}`}
              onClick={() => navigate(item.path)}
            >
              <div className="card-icon">
                {item.icon}
              </div>
              <h3 className="card-title">{item.title}</h3>
              <p className="card-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
      
    </div>
  );
};

export default Dashboard;